"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ToastTitle: function() {
        return _index.ToastTitle;
    },
    renderToastTitle_unstable: function() {
        return _index.renderToastTitle_unstable;
    },
    toastTitleClassNames: function() {
        return _index.toastTitleClassNames;
    },
    useToastTitleStyles_unstable: function() {
        return _index.useToastTitleStyles_unstable;
    },
    useToastTitle_unstable: function() {
        return _index.useToastTitle_unstable;
    }
});
const _index = require("./components/ToastTitle/index");
